import React, { Component } from 'react';
import welcomeMessageLogo from '../../images/welcomeMessage.svg';
import './welcome-message.scss'
import { Translation } from "react-i18next";
import { GetLinkForOldMyAccount } from "../../helpers/link-provider";

type Props = {
    selectedLanguage: string,
    docuwareBaseUrl: string
}

type State = {
    oldVersionLink: string
}

class WelcomeMessage extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        // Initial state
        this.state = { oldVersionLink: "" };
    }

    componentDidMount() {
        this.setLink();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.selectedLanguage !== this.props.selectedLanguage) {
            this.setLink();
        }
    }

    setLink = () => {
        let oldVersionLink = GetLinkForOldMyAccount(this.props.docuwareBaseUrl, this.props.selectedLanguage);
        this.setState({ oldVersionLink: oldVersionLink });
    }

    render() {
        return (
            <div className='welcome-message-grid'>
                <div className='welcome-message-image'>
                    <img src={welcomeMessageLogo} alt="" />
                </div>
                <div className='welcome-message-text'>
                    <h4><Translation>{t => t("Welcome to My Account")}</Translation></h4>
                    <p>
                        <Translation>
                            {t => t("This is your go-to place to find and manage general information about your account and companies.")}
                        </Translation>
                    </p>
                </div>
            </div>
        )
    }
}

export default WelcomeMessage;